import { render, staticRenderFns } from "./numeroEdition.vue?vue&type=template&id=4ffd4994&scoped=true&"
import script from "./numeroEdition.vue?vue&type=script&lang=js&"
export * from "./numeroEdition.vue?vue&type=script&lang=js&"
import style0 from "./numeroEdition.vue?vue&type=style&index=0&id=4ffd4994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffd4994",
  null
  
)

export default component.exports